import findFolders from 'owa-folders/lib/services/findFolders';
import FindFolderResponseMessage from 'owa-service/lib/contract/FindFolderResponseMessage';
import { mutatorAction } from 'satcheljs';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import getStore from '../store/store';
import BaseFolderType from 'owa-service/lib/contract/BaseFolderType';
import folderId from 'owa-service/lib/factory/folderId';
import { shouldDisplayFolderInFolderTree } from 'owa-folders';
import { getIsFolderHiddenProperty } from 'owa-folders-common';
import { compareFoldersBySize } from '../util/compareFoldersBySize';

export default function getFolderStorageInformation(): Promise<boolean> {
    const rootFolderName = 'msgfolderroot';
    return findFolders(folderId({ Id: folderNameToId(rootFolderName) }))
        .then(response => {
            if (response.ResponseClass == 'Success') {
                setFolderInformation(response);
                return true;
            } else {
                return false;
            }
        })
        .catch(error => {
            return false;
        });
}

// Gets the top 5 largest folders. Gets the junk and deleted items folder first separately, then gets the largest 5.
const setFolderInformation = mutatorAction(
    'setFolderInformation',
    (response: FindFolderResponseMessage) => {
        const filteredFolders = [];
        const store = getStore();

        for (let folder of response.RootFolder.Folders) {
            // Checking if folder is valid to be shown and deleted. Then checking if the value takes up any storage with ExtendedProperty[0].Value
            if (
                shouldDisplayFolderInFolderTree(folder) &&
                folder.ExtendedProperty[0].Value > 0 &&
                !getIsFolderHiddenProperty(folder)
            ) {
                filteredFolders.push(folder);
            }
        }

        let junkAndDeletedFolder = extractJunkAndDeletedFolders(filteredFolders);

        filteredFolders.sort(compareFoldersBySize);
        // Adding the largest to the junk folders
        store.folders = junkAndDeletedFolder.concat(filteredFolders);
    }
);

// Iterates through folders and extracts the junk items and the deleted items
function extractJunkAndDeletedFolders(filteredFolders: BaseFolderType[]) {
    const deletedItemsFolderId = folderNameToId('deleteditems');
    const junkFolderId = folderNameToId('junkemail');

    let junkAndDeletedFolder = [];

    for (let index = 0; index < filteredFolders.length; index++) {
        if (
            filteredFolders[index].FolderId.Id == deletedItemsFolderId ||
            filteredFolders[index].FolderId.Id == junkFolderId
        ) {
            junkAndDeletedFolder.push(filteredFolders[index]);
            filteredFolders.splice(index, 1); // Remove extracted folder from the list
        }
    }

    return junkAndDeletedFolder;
}
